import { useExchangeSetting } from 'app/hooks/trade/exchangeSetting'
import { useTradeStore } from 'app/hooks/trade/tradeStore'
import BigNumber from 'bignumber.js'
import React from 'react'
import { Text } from 'styles/reactnative'
import { COLORS } from '../../constants'
import { useExchangeList } from '../../hooks/trade/exchangeList'

const Quantity = ({ data }) => {
	const { data: EPs } = useExchangeList()
	const EP = EPs?.find(ep => ep?.id === data?.exchange_pairs_id)
	const coin = EP?.pairs?.split('/')[0]
	return (
		<Text style={{ justifyContent: 'flex-end' }}>
			{BigNumber(data?.amount).toFormat(EP?.dp || 3)}{' '}
			<span
				style={{
					color: COLORS.lightGray,
					fontSize: 10,
					marginLeft: 5,
					fontWeight: 'bold',
				}}>
				{coin}
			</span>
		</Text>
	)
}

export default Quantity
